import type { SidebarItem } from "../../types/auth";
import sidebarTitleJson from "./SidebarTitle.json";
import masterJson from "./Master.json";
import masterTableJson from "./MasterTable.json";

export const SIDEBAR_TITLE = sidebarTitleJson as unknown as Record<
  string,
  SidebarItem
>;
export const MASTER_UI = masterJson as Record<string, unknown>;
export const MASTER_TABLE = masterTableJson as Record<string, unknown>;
